import { render, staticRenderFns } from "./IconPencil.vue?vue&type=template&id=d132f01e&"
import script from "./IconPencil.vue?vue&type=script&lang=ts&"
export * from "./IconPencil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports